<template>
  <section class="live" :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none' }">
    <Header ref="headerEl" :openChannelId="channelId" @languageChanged="handleLanguage" v-if="showHeader" :hideWatermarkBG="showLiveWatermark" />
    <div class="live-all-container">
      <div class="live-side-banner-container" v-if="$store.state.template.banners.enableBanners && activityData.property.useSideBanners">
        <div class="live-side-banner">
          <Banner :bannerSlot="'live_side_banner_a'" :maxHeight="'unset'" />
          <!-- <img src="https://via.placeholder.com/463x1200" v-if="!isMobile">
          <img src="https://via.placeholder.com/720x120" v-else> -->
        </div>
      </div>
      <div
        class="master-container"
        :class="{
          'with-lateral-banners': $store.state.template.banners.enableBanners && activityData.property.useSideBanners && !showChat && !showQA,
          'with-lateral-banners-and-chat': $store.state.template.banners.enableBanners && activityData.property.useSideBanners && (showChat || showQA),
          'with-header': showHeader,
          solo: !showChat && !showQA,
          'full-width-mode': activityData.property.isFullWidthMode,
        }"
        :style="{ paddingTop: isUsingMinimalHeader ? (isMobile ? '0' : '70px') : '100px' }">
        <div class="player-container" id="videoContainer">
          <div ref="videoViewPort" id="liveVideoViewPort">
            <div class="player-top-header-container" ref="playerHeaderRef" :style="{ borderColor: `${activityData.trail_color ? activityData.trail_color : 'transparent'}` }" v-if="activityData.description_short || stageBanner">
              <div class="player-title" v-html="activityData.description_short" v-if="activityData.description_short"></div>
              <!-- STAGE BANNER -->
              <Banner :bannerOverwrite="stageBanner" :alignItems="'flex-end'" :maxHeight="!isMobile ? '60px' : 'auto'" :maxWidth="!isMobile ? 'max-content' : '100%'" v-if="$store.state.template.banners.enableBanners && stageBanner" />
              <!-- <img :src="stageBanner.material" v-if="stageBanner"> -->
            </div>
            <div class="player" ref="playerRef" @mouseenter="showLanguageSelector" @mouseleave="hideLanguageSelector">
              <!-- REACTIONS -->
              <div class="emoji-reactions-container" id="reactionsContainer" v-if="activityData.interactivities.comment" @mouseenter="hideLanguageSelector" @mouseleave="showLanguageSelector">
                <i v-for="(reaction, i) in activityData.property.interactivities.comment.reactions" :key="i">
                  <i :id="`${reaction.classIdle}`" :class="`generator ${reaction.classIdle}`" :style="{ color: activityData.property.interactivities.comment.config.color }" @click.prevent="sendReaction($event, reaction)"></i>
                </i>
              </div>
              <div class="interactivities-bar-fullscreen-icon-container" @click.stop="goFullScreen" v-if="!isMobile">
                <ion-icon class="interactivities-bar-fullscreen-icon" title="Fullscreen" name="scan"></ion-icon>
              </div>

              <!-- INTERACTIVITIES BAR -->
              <div class="interactivities-bar-container" :class="{ minimizeBar: minimizeBar }" ref="interactivitiesBar" id="interactivitiesBar" v-show="!hideInteractivitiesBar || showQA || showQuiz || showPoll || showWordCloud">
                <!-- <div class="minimizer-bar" title="Minimizar" @click="minimizeBar=!minimizeBar">
                  <i class="fas fa-caret-left minimizer-chevron" :class="{'rotateChevron':!minimizeBar}"></i>
                </div> -->
                <div class="interactivities-bar-icons">
                  <!-- MEETLINK -->
                  <div class="interactivities-bar-item" v-if="showMeetLink && activityData.property.meetLink && !activityData.property.meetLink.startsWith('{')" @click="openExternalLink">
                    <transition appear name="interactivitiesBarIconBounce" mode="out-in">
                      <ion-icon title="Conferência" name="cafe"></ion-icon>
                    </transition>
                    <p v-if="!isMobile">meet</p>
                  </div>
                  <!-- QUIZ -->
                  <div class="interactivities-bar-item" v-if="activityData.interactivities.quiz && interactivitiesOnStatus.some((i) => i.reference_type === 'quiz')" @click="barClickHandler('showQuiz')">
                    <transition appear name="interactivitiesBarIconBounce" mode="out-in">
                      <ion-icon title="Quiz" name="list"></ion-icon>
                    </transition>
                    <p v-if="!isMobile">
                      {{ activityData.property.interactivities.quiz.config.barText ? activityData.property.interactivities.quiz.config.barText : 'quiz' }}
                    </p>
                  </div>
                  <!-- POLL -->
                  <div class="interactivities-bar-item" v-if="activityData.interactivities.poll && interactivitiesOnStatus.some((i) => i.reference_type === 'poll')" @click="barClickHandler('showPoll')">
                    <transition appear name="interactivitiesBarIconBounce" mode="out-in">
                      <ion-icon title="Enquete" name="bar-chart"></ion-icon>
                    </transition>
                    <p v-if="!isMobile">
                      {{ activityData.property.interactivities.poll.config.barText ? activityData.property.interactivities.poll.config.barText : 'enquete' }}
                    </p>
                  </div>
                  <!-- WORDCLOUD -->
                  <div class="interactivities-bar-item" v-if="activityData.interactivities.wordcloud && interactivitiesOnStatus.some((i) => i.reference_type === 'wordcloud')" @click="barClickHandler('showWordCloud')">
                    <transition appear name="interactivitiesBarIconBounce" mode="out-in">
                      <ion-icon title="Nuvem de palavras" name="cloud"></ion-icon>
                    </transition>
                    <p v-if="!isMobile && activityData.property.interactivities.wordcloud">
                      {{ activityData.property.interactivities.wordcloud.config.barText ? activityData.property.interactivities.wordcloud.config.barText : 'nuvem' }}
                    </p>
                  </div>
                  <!-- <div class="interactivities-bar-item" v-if="showQA" @click="barClickHandler('showQuestionOverlay')">
                    <transition appear name="interactivitiesBarIconBounce" mode="out-in">
                      <ion-icon title="Perguntar" name="help-circle"></ion-icon>
                    </transition>
                    <p v-if="!isMobile">
                      {{ activityData.property.interactivities.qa.config.barText ? activityData.property.interactivities.qa.config.barText : 'perguntar' }}
                    </p>
                  </div> -->
                </div>
              </div>

              <!-- WORDCLOUD -->
              <transition :name="transitionName" mode="out-in">
                <WordCloudPrompt
                  :topRef="topQA"
                  :leftRef="leftQA"
                  :isMobile="isMobile"
                  :isVideoFullscreen="isVideoFullscreen"
                  :wordcloud="currentWordcloud"
                  :wordcloud_id="wordcloudId"
                  :prompt="wordcloudPrompt"
                  :panelTitle="activityData.property.interactivities.wordcloud.config.panelTitle"
                  :sendText="activityData.property.interactivities.wordcloud.config.sendBtnText ? activityData.property.interactivities.wordcloud.config.sendBtnText : 'ENVIAR'"
                  :postSendText="activityData.property.interactivities.wordcloud.config.postSendText ? activityData.property.interactivities.wordcloud.config.postSendText : 'Obrigado! Nossa nuvem de palavras está sendo criada!'"
                  v-if="showWordCloud"
                  @close="showWordCloud = false"
                  :z="panelZ.wordcloud"
                  @bringToFront="bringToFront($event)" />
              </transition>

              <!-- Q&A -->
              <!-- <img class="btnQuestion" :src="activityData.property.qnaImage" v-if="showQA && !showQuestionOverlay && activityData.property.qnaImage" @click.prevent="showQuestionOverlay = true" />
              <transition :name="transitionName" mode="out-in">
                <VueDragResize
                  class="question-overlay"
                  :parentLimitation="false"
                  :isResizable="false"
                  :h="heightQA"
                  :w="widthQA"
                  :z="panelZ.qa"
                  @clicked="bringToFront('qa')"
                  :x="leftQA"
                  :y="topQA"
                  @dragging="resizeQA"
                  @dragstop="dragstop"
                  v-if="showQuestionOverlay"
                  :style="{ opacity: panelZ.qa == 2 ? 1 : 0.7 }">
                  <div class="wordcloud-header">
                    <h3 class="wordcloud-box-title" v-html="activityData.property.interactivities.qa.config.barText"></h3>
                    <div
                      class="wordcloud-close-button"
                      href="#"
                      @click.prevent="barClickHandler('showQuestionOverlay')"
                      @touchstart="
                        question = '';
                        barClickHandler('showQuestionOverlay');
                      ">
                      X
                    </div>
                  </div>
                  <textarea
                    v-focus
                    ref="qaTextArea"
                    class="input-question"
                    spellcheck="false"
                    rows="8"
                    v-model="question"
                    @keypress="checkSendQuestion"
                    :placeholder="activityData.property.interactivities.qa.config.placeholder ? activityData.property.interactivities.qa.config.placeholder : 'Escreva sua pergunta...'"
                    @click.prevent="passQAFocus"
                    @touchstart="passQAFocus"></textarea>
                  <button class="question-send-button" @click.prevent="sendGeneralQuestion" @touchstart="sendGeneralQuestion">
                    {{ activityData.property.interactivities.qa.config.sendBtnText ? activityData.property.interactivities.qa.config.sendBtnText : 'ENVIAR' }}
                  </button>
                </VueDragResize>
              </transition> -->

              <!-- POLL -->
              <transition :name="transitionName" mode="out-in">
                <Poll
                  class="poll"
                  :config="activityData.property.interactivities.poll.config"
                  :currentPoll="currentPoll"
                  :topRef="topRef"
                  :leftRef="leftRef"
                  :isMobile="isMobile"
                  :isVideoFullscreen="isVideoFullscreen"
                  :rawData="currentPoll ? currentPoll : {}"
                  ref="poll"
                  :title="activityData.property.interactivities.poll.config.pollTitle"
                  :resultsTitle="activityData.property.interactivities.poll.config.pollResultsTitle"
                  :z="panelZ.poll"
                  @bringToFront="bringToFront($event)"
                  @hidePoll="showPoll = false"
                  @finished="finishPoll"
                  v-show="showPoll" />
              </transition>

              <!-- QUIZ -->
              <transition :name="transitionName" mode="out-in">
                <Quiz
                  class="quiz"
                  :topRef="topRef"
                  :leftRef="leftRef"
                  :isMobile="isMobile"
                  :isVideoFullscreen="isVideoFullscreen"
                  :currentQuiz="currentQuiz"
                  :rawData="currentQuiz ? currentQuiz : {}"
                  ref="quiz"
                  id="quiz"
                  :title="activityData.property.interactivities.quiz.config.quizTitle"
                  :resultsTitle="activityData.property.interactivities.quiz.config.quizResultsTitle"
                  :z="panelZ.quiz"
                  @bringToFront="bringToFront($event)"
                  @hideQuiz="showQuiz = false"
                  @finished="finishQuiz"
                  v-show="showQuiz" />
              </transition>

              <!-- VIDEO BANNER -->
              <div class="live-video-banner-container" v-if="$store.state.template.banners.enableBanners && videoBanner">
                <Banner :bannerOverwrite="videoBanner" />
                <!-- <img :src="videoBanner.material" v-if="videoBanner"> -->
              </div>

              <!-- MEETING -->
              <a target="_blank" :href="activityData.property.meetLink" v-if="!activityData.property.fullMeet">
                <img v-if="showMeetLink && activityData.property.meetLinkImage" class="btnMeeting" :src="activityData.property.meetLinkImage" />
              </a>

              <!-- FULL MEETING -->
              <div class="full-meet-container" v-if="showFullMeetLink && activityData.property.fullMeet">
                <div class="full-meet-wrapper">
                  <button class="full-meet-closeBtn" @click.prevent="showFullMeetLink = false" v-if="fullMeet.closable"></button>
                  <img v-if="showMeetLink" class="full-meet-img" :src="fullMeet.img" @click.prevent="handleFullMeet" />
                </div>
              </div>

              <!-- PIP / LINKS -->
              <div
                class="links-overlay-container"
                :style="{ justifyContent: link.config ? link.config.justify : 'flex-end', alignItems: link.config ? link.config.align : 'flex-end' }"
                v-for="(link, k) in links"
                :key="k"
                v-show="link.links_id">
                <a class="link-onscreen" :href="link.link" target="_blank" @click.prevent="openLink(link)" v-if="!link.config.isPIP && !link.config.usePreview">
                  <img v-if="link.image" class="link-onscreen-image" :src="link.image" />
                </a>
                <a class="link-onscreen" :href="link.link" target="_blank" @click.prevent="handlePIPList(link.links_id)" v-if="link.config.isPIP && !link.config.usePreview">
                  <img class="link-onscreen-image" :src="link.image" v-if="link.image && !activePIPList.includes(link.links_id)" />
                </a>
                <VideoJSPlayer
                  class="pip-preview-video-player"
                  :options="{ autoplay: true, controls: false, sources: [{ src: link.link, type: 'application/x-mpegURL' }] }"
                  @videoClicked="handlePIPList(link.links_id)"
                  v-if="link.config.isPIP && link.config.usePreview && !activePIPList.includes(link.links_id) && link.link.endsWith('.m3u8')" />
                <div class="pip-link-onscreen" @click="handlePIPList(link.links_id)" v-if="link.config.isPIP && link.config.usePreview">
                  <iframe muted class="pip-preview-iframe" :src="link.link" frameborder="0" allow="autoplay" v-if="!activePIPList.includes(link.links_id) && !link.link.endsWith('.m3u8')"></iframe>
                </div>
                <PIP :source="link.link" v-if="activePIPList.includes(link.links_id)" @close="handlePIPList(link.links_id)" />
              </div>
              <!-- OVERLAY - 'GERADOR DE CARACTERES' -->
              <lower-third ref="lowerThird" />

              <!-- IFRAME -->
              <div v-if="streamActive && !useVJS" class="video-container">
                <iframe class="vimeo-iframe" :src="`${activityData.property.srcVideo}`" v-if="streamActive" frameborder="0" allow="autoplay; fullscreen" @click="logClick"></iframe>
              </div>

              <!-- VIDEO-JS -->
              <div v-if="streamActive && useVJS" class="video-container">
                <VideoJSPlayer ref="vjsPlayer" :options="{ autoplay: true, controls: true, sources: [{ src: activityData.property.srcVideo, type: 'application/x-mpegURL' }] }" />
                <!-- <VideoJSPlayer :options="{autoplay: true, controls: true, userActions: {doubleClick: false}, sources: [{src: 'http://qthttp.apple.com.edgesuite.net/1010qwoeiuryfg/sl.m3u8', type: 'application/x-mpegURL'}]}"/> -->
              </div>

              <!-- POSTER -->
              <img class="poster-live" ref="poster" :src="activityData.images.poster" alt :style="[streamActive ? { zIndex: '-1' } : { zIndex: '0' }]" />
              <!-- CURTAIN -->
              <img class="poster-live" v-if="currentCurtain" :src="currentCurtain.image" />
              <!-- WATERMARK -->
              <span class="live-watermark-bg" v-if="showLiveWatermark">
                <p class="username-tilt">{{ $store.state.user.name }}</p>
              </span>
            </div>
          </div>

          <!-- LANGUAGE SELECTOR -->
          <div ref="languageSelector" class="language-selector-container" v-if="activityData.property.languagesVideo && streamActive">
            <span class="language-selector-wrapper">
              <img src="https://proto-assets.s3.amazonaws.com/semesp/plenaria/translate.svg" alt />
              <select required class="language-selector-select" @change="onOptionChange($event)" v-model="languagesVideoModel">
                <option class="selector-option is-disabled" value="" disabled>Idioma</option>
                <option class="selector-option" v-for="(language, key) in activityData.property.languagesVideo" :key="key" :value="language.video">{{ language.lang }}</option>
              </select>
            </span>
          </div>

          <!-- STREAM DETAILS -->
          <div class="stream-details" v-focus @click.prevent="passFocus" ref="streamDetails" v-if="activityData.property.liveDescription">
            <p class="stream-description" v-html="activityData.property.liveDescription"></p>
          </div>
          <!-- SPEAKERS -->
          <div class="speaker" v-if="activityData.property.speakers && activityData.property.speakers.length">
            <div class="speaker-details" v-for="(speaker, i) in activityData.property.speakers" :key="i">
              <img class="speaker-picture" :src="speaker.picture" alt />
              <div class="speaker-info">
                <span class="speaker-name">{{ speaker.speaker }}</span>
                <span class="speaker-role">{{ speaker.role }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- SIDEBOX -->
        <transition name="chat-translate" mode="out-in">
          <Sidebox ref="sideboxRef" :showQA="showQA" :activityData="activityData" v-if="showChat || showQA" />
        </transition>
      </div>
      <div class="live-side-banner-second-container" v-if="$store.state.template.banners.enableBanners && activityData.property.useSideBanners">
        <div class="live-side-banner live-side-banner-second">
          <Banner :bannerSlot="'live_side_banner_b'" :maxHeight="'unset'" />
          <!-- <img class="live-side-banner-second-image" src="https://via.placeholder.com/463x1200" v-if="!isMobile">
          <img class="live-side-banner-second-image" src="https://via.placeholder.com/720x120" v-else> -->
        </div>
      </div>
    </div>
    <div class="feed-container-embed" v-if="showFeed">
      <Feed @openMessageChannel="openMessageChannel" />
    </div>
    <div class="footer-image-container" v-if="accessConfig.footerImage">
      <div v-html="accessConfig.footerImage"></div>
    </div>
    <div class="footer-wrapper">
      <Footer />
    </div>
  </section>
</template>
<script>
import api from '@/services/api';
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import Quiz from '@/components/interactivities/Quiz.vue';
import Poll from '@/components/interactivities/Poll.vue';
import LowerThird from '@/components/interactivities/LowerThird.vue';
import WordCloudPrompt from '@/components/interactivities/WordCloudPrompt.vue';
import VideoJSPlayer from '@/components/general/VideoJSPlayer.vue';
import Feed from '../components/user_content/Feed.vue';
import Banner from '@/components/banners/Banner.vue';
import VueDragResize from 'vue-drag-resize';
import PIP from '@/components/live/PIP.vue';
import Sidebox from '@/components/chat_qa_box/Sidebox.vue';

export default {
  name: 'Live',
  components: {
    Header,
    Quiz,
    Poll,
    Footer,
    VideoJSPlayer,
    Feed,
    LowerThird,
    WordCloudPrompt,
    Banner,
    VueDragResize,
    PIP,
    Sidebox,
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.focus();
      },
    },
  },
  data() {
    return {
      updaterSetInterval: null,
      loadActivityIntervalInMiliseconds: 90000,
      isAdmin: false,
      accessConfig: {
        interactivities: {
          pollTitle: 'ENQUETE',
          pollResultsTitle: 'RESULTADO',
          quizTitle: 'QUIZ',
          quizResultsTitle: 'Você acertou',
          qnaPlaceholder: 'Sua pergunta...',
        },
      },
      channelId: '',
      windowWidth: window.innerWidth,
      minimizeBar: true,
      showHeader: true,
      showChat: false,
      showQuiz: false,
      showPoll: false,
      showWordCloud: false,
      currentPoll: null,
      currentQuiz: null,
      tempLinks: [],
      showQA: false,
      showMeetLink: false,
      showFullMeetLink: false,
      showFeed: false,
      audio: null,
      volumeSlider: 50,
      useVJS: false,
      showQuestionOverlay: false,
      showLiveWatermark: false,
      hideInteractivitiesBar: false,
      sideboxHeight: '',
      message: '',
      wsClient: null,
      pinnedChatMessages: [],
      showPinnedChatMessages: true,
      messages: [],
      countMsg: 0,
      question: '',
      stageBanner: null,
      videoBanner: null,
      player: null,
      isVideoFullscreen: false,
      languagesVideoModel: '',
      template: null,
      streamActive: false,
      qnaActive: false,
      notificationActive: false,
      notification: {
        notification_message: '',
      },
      fullMeet: {},
      reactionApiBusy: false,
      reactionApiTimeout: 1000,
      reactionColor: null,
      activityData: {
        activity: '',
        images: {},
        speaker: [],
        interactivities: {
          chat: true,
          qa: false,
          quiz: false,
          poll: false,
          wordcloud: false,
        },
        property: {
          showBar: false,
          srcVideo: '',
          meetlink: '',
          languagesVideo: [],
          fullMeet: { closable: false, url: '', img: '' },
          interactivities: { quiz: { config: { quizTitle: 'QUIZ', quizResultsTitle: 'Você acertou' } }, poll: { config: { pollTitle: 'ENQUETE', pollResultsTitle: 'RESULTADO' } } },
          //chatGraphQL: false,
        },
      },
      currentWordcloud: null,
      wordcloudId: '',
      wordcloudPrompt: '',
      showWordCloudPrompt: false,
      currentCurtain: null,
      links: [],
      reaction: [
        { name: 'thumbs-up', classIdle: 'far fa-thumbs-up', classAnimate: 'fas fa-thumbs-up' },
        { name: 'heart', classIdle: 'far fa-heart', classAnimate: 'fas fa-heart' },
        { name: 'star', classIdle: 'far fa-star', classAnimate: 'fas fa-star' },
      ],
      subscriptionGraphQL: null,
      widthQA: 100,
      heightQA: 40,
      topQA: 140,
      leftQA: 220,
      topRef: 140,
      leftRef: 220,
      panelZ: { qa: 1, quiz: 1, poll: 1, wordcloud: 1 },
      isDragging: false,
      interactivitiesOnStatus: [],
      showPIP: true,
      activePIPList: [],
      selectedSideInteraction: 'chat',
      currentWSChannel: null,
    };
  },
  computed: {
    transitionName() {
      if (window.innerWidth > 730) {
        return 'qna-bounce';
      } else {
        return '';
      }
    },
    isMobile: {
      get() {
        return this.windowWidth < 920;
      },
      set(value) {
        return value;
      },
    },
    isUsingMinimalHeader() {
      return this.$store.state.template.header.useMinimalHeader;
    },
  },
  watch: {
    $route() {
      this.loadActivity();
    },
    volumeSlider: (newVal, oldVal) => {
      // console.log('neVAL: ' + newVal);
      this.$nextTick((_) => {
        this.$refs.vjsPlayer.volume = newVal / 100;
      });
    },
  },
  methods: {
    loadActivity(isUpdate) {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then((response) => {
          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

          let tempProperty = { ...this.activityData.property };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;
          this.reactionApiTimeout = this.activityData.property.interactivities?.comment?.config?.apiTimeout;

          if (isUpdate) {
            response.data.interactivity.forEach((item) => {
              if (item.interactivity === 'chat') {
                this.activityData.interactivities[item.interactivity] = item.enable;
              }
              if (item.interactivity === 'comment') {
                this.activityData.interactivities[item.interactivity] = item.enable;
              }
            });
          }
          if (!isUpdate) {
            response.data.interactivity.forEach((item) => {
              this.activityData.interactivities[item.interactivity] = item.enable;
            });
          }
          this.showChat = this.activityData.interactivities.chat;
          this.showLiveWatermark = this.activityData.property.showLiveWatermark ?? false;
          this.hideInteractivitiesBar = this.activityData.property.hideInteractivitiesBar ? true : false;
          this.minimizeBar = this.activityData.property.minimizeBar ? true : false;

          if (!isUpdate && this.activityData.property.languagesVideo) this.languagesVideoModel = this.activityData.property?.srcVideo;
          if (isUpdate && this.activityData.property.languagesVideo && this.activityData.property.srcVideo != this.languagesVideoModel) {
            this.activityData.property.srcVideo = this.languagesVideoModel;
          }

          if (this.activityData.property.srcVideo.endsWith('.m3u8')) {
            console.log('M3U8');
            this.useVJS = true;
          } else {
            this.useVJS = false;
          }

          if (!isUpdate) {
            if (!this.activityData.property.silenceWS) {
              this.connectWs();
            }
          }

          this.handleLanguage(this.$store.state.user.language);
          this.apiGetInteractivitiesStatus(isUpdate);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    apiGetInteractivitiesStatus(isUpdate) {
      let nonChatInteractivities = { ...this.activityData.interactivities };
      if (nonChatInteractivities.chat) delete nonChatInteractivities.chat;
      if (!Object.values(nonChatInteractivities).some((i) => i === true)) return;
      if (
        this.activityData.interactivities.character_generator ||
        this.activityData.interactivities.comment ||
        this.activityData.interactivities.curtains ||
        this.activityData.interactivities.links ||
        this.activityData.interactivities.poll ||
        this.activityData.interactivities.quiz ||
        this.activityData.interactivities.wordcloud ||
        this.activityData.interactivities.qa
      ) {
        api
          .get(`event/${this.$store.state.eventId}/channels/${this.$route.params.stream}/status`)
          .then((response) => {
            // console.log('apiGetInteractivitiesStatus Response: ', { response });
            this.activityData.interactivities.quiz = false;
            this.activityData.interactivities.poll = false;
            this.activityData.interactivities.wordcloud = false;
            this.interactivitiesOnStatus = response.data;
            this.links = [];
            response.data.map(async (interactivity) => {
              // console.log('Interactivity: ' + JSON.stringify(interactivity.reference_type));
              try {
                if (interactivity.reference_type == 'wordcloud') {
                  let wordcloud = JSON.parse(interactivity.raw_data);
                  // console.log('wordcloud', { interactivity });
                  if (!wordcloud.language_code || wordcloud.language_code == null || wordcloud.language_code == this.$store.state.user.language) {
                    this.activityData.interactivities.wordcloud = true;
                    this.currentWordcloud = wordcloud;
                    this.wordcloudId = wordcloud.wordcloud_id;
                    this.wordcloudPrompt = wordcloud.question;
                    this.checkWords({ id: interactivity.interactivity_id });
                    setTimeout(() => {
                      if (!isUpdate) {
                        this.showWordCloudPrompt = true;
                        this.showWordCloud = true;
                      } else if (isUpdate && !this.showWordCloudPrompt) {
                        this.showWordCloudPrompt = false;
                        this.showWordCloud = false;
                      }
                    }, 200);
                  }
                }
                if (interactivity.reference_type == 'poll') {
                  let poll = JSON.parse(interactivity.raw_data);
                  // console.log('interactivity: ', { interactivity });

                  if (!poll.language_code || poll.language_code == null || poll.language_code == this.$store.state.user.language) {
                    this.activityData.interactivities.poll = true;

                    if (poll.type.showResults) {
                      poll.answers = await this.getPollResults(poll.poll_id);
                      poll.interactions = poll.answers.reduce((acc, interactions) => acc + interactions, 0);
                      // interactivity.raw_data.answers = poll.answers;
                    }
                    this.currentPoll = { ...interactivity, ...poll };
                    this.$nextTick((_) => {
                      if (this.$refs.poll !== undefined) {
                        this.$refs.poll.beginPoll(poll);
                        // console.log('interactivity: ', { interactivity });
                        if (interactivity.interacted) {
                          this.$refs.poll.updatePoll(poll.answers, poll.interactions);
                        }
                        // let marker = `${this.$store.state.user.id}-${poll.poll_id}`;
                        if (!isUpdate && !interactivity.interacted) this.showPoll = true;
                        else if (isUpdate && this.showPoll) this.showPoll = true;
                        else {
                          this.showPoll = false;
                        }
                      }
                    });
                  }
                }
                if (interactivity.reference_type == 'quiz') {
                  let quiz = JSON.parse(interactivity.raw_data);
                  // console.log('quiz interactivity: ', { interactivity });

                  // dont get already answered quizzes
                  let marker = `${this.$store.state.user.id}-${quiz.id}`;
                  // Re-populate marker from server state (handles page refresh / store reset)
                  if (interactivity.interacted && !this.$store.state.markers.answeredQuiz.includes(marker)) {
                    this.$store.commit('setMarker', { target: 'answeredQuiz', marker: marker });
                  }
                  if (this.$store.state.markers.answeredQuiz.includes(marker)) {
                    this.interactivitiesOnStatus = this.interactivitiesOnStatus.filter((i) => i !== interactivity);
                    this.showQuiz = false;
                    return;
                  }
                  if (!quiz.language_code || quiz.language_code == null || quiz.language_code == this.$store.state.user.language) {
                    this.activityData.interactivities.quiz = true;

                    this.currentQuiz = { ...interactivity, ...quiz };
                    this.$nextTick((_) => {
                      if (this.$refs.quiz !== undefined) {
                        if (!isUpdate && !interactivity.interacted) this.showQuiz = true;
                        else if (isUpdate && this.showQuiz) this.showQuiz = true;
                        else this.showQuiz = false;

                        this.bringToFront('quiz');
                      }
                    });
                  }
                }
                if (interactivity.reference_type == 'curtains') {
                  let curtains = JSON.parse(interactivity.raw_data);
                  if (!curtains.language_code || curtains.language_code == null || curtains.language_code == this.$store.state.user.language) {
                    this.currentCurtain = curtains;
                  }
                }
                if (interactivity.reference_type == 'links') {
                  // console.log('links interactivity: ', { interactivity });
                  let links = JSON.parse(interactivity.raw_data);
                  if (!links.language_code || links.language_code == null || links.language_code == this.$store.state.user.language) {
                    this.links.push(links);
                  }
                }
                if (interactivity.reference_type == 'character_generator') {
                  let character_generator = JSON.parse(interactivity.raw_data);
                  // console.log('character_generator: ' + interactivity.raw_data);
                  if (!character_generator.language_code || character_generator.language_code == null || character_generator.language_code == this.$store.state.user.language) {
                    // console.log('character_generator.text: ' + character_generator.text);
                    this.$nextTick(() => {
                      character_generator.lowerthird = character_generator;
                      this.$refs.lowerThird.updateAndShow(character_generator);
                    });
                  }
                }
                if (interactivity.reference_type == 'banner_top') {
                  // console.log('banner_top: ', { interactivity });
                  this.stageBanner = JSON.parse(interactivity.raw_data);
                  this.$nextTick(() => {
                    this.resized();
                  });
                }
                if (interactivity.reference_type == 'banner_video') {
                  // console.log('banner_top: ', { interactivity });
                  this.videoBanner = JSON.parse(interactivity.raw_data);
                }
                if (interactivity.reference_type == 'live') {
                  if (interactivity.raw_data) {
                    interactivity.raw_data.map((msg) => {
                      this.receiveMessage({ data: msg }, isUpdate);
                    });
                  }
                }
              } catch (err) {
                console.error('Error processing interactivity:', err);
              }
            });
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    openMessageChannel(channelId) {
      // console.log('openMessageChannel on Live: ' + channelId);
      this.channelId = '';
      this.$nextTick(() => {
        this.channelId = channelId;
      });
    },
    async openLink(link) {
      api.post(`sessionAction/`, {
        action: 'Live Link action',
        properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, link: link }),
        userid: this.$store.state.user.id,
        sessionid: this.$store.state.user.token,
        event_id: this.$store.state.eventId,
      });
      if (link.config.hideOnClick) {
        if (link.config.playSound) {
          const sound = new Audio(link.config.soundToPlay);
          sound.play();
          await new Promise((resolve) => setTimeout(resolve, 1000));
        }
        this.links = this.links.filter((l) => l.links_id != link.links_id);
      } else if (link.link.startsWith('http')) window.open(link.link);
      else {
        try {
          const parsedRoute = JSON.parse(link.link);
          window.open(`${document.location.hostname == 'localhost' ? 'http://localhost:8080' : `https://${document.location.hostname}`}/#/${parsedRoute.name}/${parsedRoute.params.stream}/${parsedRoute.params.standFromLink ?? ''}`);
        } catch (error) {}
      }
    },
    goFullScreen() {
      let element = this.$refs.playerRef;
      if (!this.isVideoFullscreen) {
        element.webkitRequestFullscreen();
        this.isVideoFullscreen = true;
      } else {
        document.webkitExitFullscreen();
        this.isVideoFullscreen = false;
      }
    },
    handleLanguage(selectedLanguage) {
      // console.log('language changed on header to: ' + selectedLanguage);
      if (selectedLanguage == 'PT') this.fullMeet = this.activityData.property.fullMeet;
      else if (selectedLanguage == 'EN') this.fullMeet = this.activityData.property.fullMeet_en;
    },
    handleFullMeet() {
      this.loadActivity(true);
      if (this.activityData.property.meetLink != '') {
        window.open(this.activityData.property.meetLink);
      } else if (this.fullMeet.url != '') {
        window.open(this.fullMeet.url);
      } else if (this.fullMeet.route.name != '') {
        this.$router.push(this.fullMeet.route);
      }
    },
    openExternalLink() {
      window.open(this.activityData.property.meetLink, '_blank');
    },
    onOptionChange(event) {
      this.streamActive = false;
      this.activityData.property.srcVideo = '';
      if (event.target.value.endsWith('.m3u8')) {
        this.useVJS = true;
      } else {
        this.useVJS = false;
      }
      this.$nextTick((_) => {
        this.activityData.property.srcVideo = event.target.value;
        this.streamActive = true;
      });
    },
    sendGeneralQuestion() {
      if (this.isDragging) return;

      // console.log('question', this.question, this.question.length);
      if (this.question.length > 0 && this.question.length <= 3000) {
        let msg = {
          type: 'send-question',
          channel: this.$route.params.stream,
          userId: this.$store.state.user.id,
          name: this.$store.state.user.name,
          text: this.question,
          theme: this.activityData.property.interactivities.qa.config.useThemes && this.activityData.property.interactivities.qa.config.currentTheme ? this.activityData.property.interactivities.qa.config.currentTheme : null,
          properties: null,
        };
        api
          .post(`send-question/${this.$route.params.stream}`, msg)
          .then((response) => {
            this.question = '';
            this.showQuestionOverlay = false;
            api.post(`sessionAction/`, {
              action: 'Question Send',
              properties: JSON.stringify(msg),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          })
          .catch((err) => {
            console.error('error sending question', err);
          });
      }
    },
    receiveMessage(incoming, isUpdate) {
      let msg = JSON.parse(incoming.data);
      // console.log('receiveMessage', msg.type, { msg });
      if (msg.type == 'subscribed') {
        api
          .post('subscribeClient', {
            connectionId: msg.connectionId,
            data: {
              channel: msg.channel,
            },
          })
          .then((response) => {
            if (response.data && response.data.data) {
              response.data.data.map((msg) => {
                this.receiveMessage({ data: msg }, isUpdate);
              });
            }
          })
          .catch((err) => console.error('error subscribing', err));
      } else if (msg.type == 'update-activity') {
        // console.log('update-activity msg', { msg });
        try {
          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...msg.updateActivity };
          this.activityData.images = msg.updateActivity.images ? JSON.parse(msg.updateActivity.images) : tempImages;
          this.activityData.property = JSON.parse(this.activityData.property);
          msg.updateActivity.interactivity.forEach((item) => {
            this.activityData.interactivities[item.interactivity] = item.enable;
          });
          // Prevent re-enabling quiz icon if the user already answered it (not in interactivitiesOnStatus)
          if (this.activityData.interactivities.quiz && !this.interactivitiesOnStatus.some((i) => i.reference_type === 'quiz')) {
            this.activityData.interactivities.quiz = false;
          }
          this.showChat = this.activityData.interactivities.chat;
          if (!this.showQA) this.selectedSideInteraction = 'chat';
          this.$nextTick((_) => {
            this.resized();
          });
        } catch (error) {
          console.error('error parsing activity property', error);
        }
      } else if (msg.type == 'reaction-input') {
        //this.reaction.push(msg);
        msg.config = JSON.parse(msg.config);
        // SINGLE ANIMATION
        // this.animateReaction({ target: document.getElementById(msg.config.classIdle) }, msg.config, true);

        // MULTIPLE ANIMATION
        let refreshIntervalId = setInterval(() => {
          this.animateReaction({ target: document.getElementById(msg.config.classIdle) }, msg.config, true);
        }, 140);
        setTimeout(() => {
          clearInterval(refreshIntervalId);
        }, 500);
      } else if (msg.type == 'show-curtains') {
        if (msg.curtains.language_code == null || msg.curtains.language_code == this.$store.state.user.language) {
          this.currentCurtain = msg.curtains;
        }
      } else if (msg.type == 'hide-curtains') {
        this.currentCurtain = null;
      } else if (msg.type == 'begin-quiz') {
        // console.log('beginQuiz', { msg });
        if (msg.quizQuestions.language_code == '' || msg.quizQuestions.language_code == null || msg.quizQuestions.language_code == this.$store.state.user.language) {
          let marker = `${this.$store.state.user.id}-${msg.quizQuestions.id}`;
          if (this.$store.state.markers.answeredQuiz.includes(marker)) return;

          if (!this.interactivitiesOnStatus.some((i) => i.reference_type === 'quiz')) {
            this.interactivitiesOnStatus.push({ reference_type: 'quiz' });
          }
          this.$nextTick((_) => {
            this.currentQuiz = msg.quizQuestions;
            this.activityData.interactivities.quiz = true;
            this.showQuiz = true;
            this.bringToFront('quiz');
            if (!isUpdate) this.flashInteractivitiesBar();
          });
        }
      } else if (msg.type == 'end-quiz') {
        // console.log('endQuiz', { msg });
        try {
          if (this.currentQuiz && msg.quiz.quiz_id === this.currentQuiz.id) {
            this.currentQuiz = null;
            this.activityData.interactivities.quiz = false;
            this.showQuiz = false;
          }
          this.apiGetInteractivitiesStatus();
        } catch (error) {}
      } else if (msg.type == 'quiz-score') {
        this.$refs.quiz.setScore(msg.score);
      } else if (msg.type == 'begin-poll') {
        // console.log('begin-poll', { msg });
        if (msg.poll.language_code == null || msg.poll.language_code == this.$store.state.user.language) {
          if (!this.interactivitiesOnStatus.some((i) => i.reference_type === 'poll')) {
            this.interactivitiesOnStatus.push({ reference_type: 'poll' });
          }
          this.activityData.interactivities.poll = true;
          this.showPoll = true;
          if (!isUpdate) this.flashInteractivitiesBar();
          this.$nextTick(() => {
            this.currentPoll = msg.poll;
            if (this.$refs.poll !== undefined) {
              this.$refs.poll.beginPoll(msg.poll);
              if (msg.poll.interactions) {
                this.$refs.poll.updatePoll(msg.poll.answers, msg.poll.interactions);
              }
              this.bringToFront('poll');
            }
          });
        }
      } else if (msg.type == 'end-poll') {
        // console.log('end-poll: ', { msg });
        if (msg.poll.poll_id == this.currentPoll.id) {
          this.activityData.interactivities.poll = false;
        }
        this.showPoll = false;
        this.apiGetInteractivitiesStatus(true);
      } else if (msg.type == 'update-interaction-poll') {
        // console.log('update-interaction-poll: ', { msg });
        this.$nextTick(() => {
          if (this.$refs.poll !== undefined) this.$refs.poll.updatePoll(msg.answers, msg.totalVotes);
        });
      } else if (msg.type == 'begin-notification') {
        this.notificationActive = true;
        //this.notification = msg.notification;
        //console.log('Begin Notification!', msg);
      } else if (msg.type == 'end-notification') {
        this.notificationActive = false;
      } else if (msg.type == 'qna-live') {
        // console.log('receiveMessage', msg.type, msg.value);
        this.showQA = msg.value;
        if (this.showQA) {
          if (this.isMobile) {
            this.topQA = 100;
            this.leftQA = 50;
          }
          this.activityData.interactivities.qna = true;
          if (!isUpdate) this.flashInteractivitiesBar();
          this.$nextTick(() => {
            this.resized();
          });
        }
      } else if (msg.type == 'link-live') {
        const meetLinkBefore = this.showMeetLink;
        this.showMeetLink = msg.value;
        this.showFullMeetLink = msg.value;
        if (this.activityData.property.meetLink && !this.activityData.property.meetLink.startsWith('{')) {
          this.showMeetLink = true;
          if (!isUpdate) this.flashInteractivitiesBar();
        }
      } else if (msg.type == 'show-links') {
        if (!msg.links.language_code || msg.links.language_code == this.$store.state.user.language) {
          this.links.push(msg.links);
        }
      } else if (msg.type == 'hide-links') {
        this.links = this.links.filter((link) => link.links_id !== msg.links.links_id);
      } else if (msg.type == 'header-show') {
        this.showHeader = msg.value;
      } else if (msg.type == 'stream-live') {
        this.streamActive = msg.value;
        this.$gtag.event('stream', {
          event_category: 'stream_status',
          value: msg.value ? 'started' : 'stopped',
        });
        if (!this.streamActive) {
          this.$nextTick(() => {
            // this.player = videojs(this.$refs.player);
            // this.player.play();
          });
        }
      } else if (msg.type == 'show-lowerthird') {
        if (msg.lowerthird.language_code == null || msg.lowerthird.language_code == this.$store.state.user.language) {
          this.$nextTick(() => {
            this.$refs.lowerThird.updateAndShow(msg);
          });
        }
      } else if (msg.type == 'hide-lowerthird') {
        if (msg.lowerthird.language_code == null || msg.lowerthird.language_code == this.$store.state.user.language) {
          this.$refs.lowerThird.hide();
        }
      } else if (msg.type == 'show-wordcloud-prompt') {
        if (msg.wordcloud?.language_code == null || msg.wordcloud?.language_code == this.$store.state.user.language) {
          if (!this.interactivitiesOnStatus.some((i) => i.reference_type === 'wordcloud')) {
            this.interactivitiesOnStatus.push({ reference_type: 'wordcloud' });
          }
          this.activityData.interactivities.wordcloud = true;
          if (!isUpdate) this.flashInteractivitiesBar();
          this.$nextTick((_) => {
            this.currentWordcloud = msg.wordcloud;
            this.wordcloudId = msg.wordcloud.wordcloud_id;
            this.wordcloudPrompt = msg.wordcloud.question;
            this.showWordCloud = true;
            this.showWordCloudPrompt = true;
          });
        }
      } else if (msg.type == 'hide-wordcloud-prompt') {
        // console.log('receiveMessage', msg);
        if (msg.wordcloud.wordcloud_id == this.wordcloudId) {
          this.activityData.interactivities.wordcloud = false;
          this.showWordCloudPrompt = false;
          this.showWordCloud = false;
          this.currentWordcloud = null;
        }
        this.apiGetInteractivitiesStatus();
      } else if (msg.type == 'update-interaction-wordcloud') {
        //  console.log('update-interaction-wordcloud', { msg });
        this.checkWords(msg);
      } else if (msg.type == 'show-banner-top') {
        // console.log('receiveMessage show-banner-top', msg);
        this.stageBanner = msg.banner_top;
        this.$nextTick(() => {
          this.resized();
        });
      } else if (msg.type == 'hide-banner-top') {
        // console.log('receiveMessage hide-banner-top', msg);
        this.stageBanner = null;
        this.$nextTick(() => {
          this.resized();
        });
      } else if (msg.type == 'show-banner-video') {
        this.videoBanner = msg.banner_video;
      } else if (msg.type == 'hide-banner-video') {
        this.videoBanner = null;
      }
    },
    flashInteractivitiesBar() {
      if (!this.$refs.interactivitiesBar) return;
      this.$refs.interactivitiesBar.style['visibility'] = 'visible';
      setTimeout(() => {
        if (this.$refs.interactivitiesBar) {
          if (this.activityData.property.minimizeBar) this.minimizeBar = true;
          this.$refs.interactivitiesBar.style['visibility'] = 'hidden';
        }
      }, 5000);
    },
    barClickHandler(item) {
      switch (item) {
        case 'showQuiz':
          // this.showPoll = false;
          // this.showWordCloud = false;
          // this.showWordCloudPrompt = false;
          // this.showQuestionOverlay = false;
          this.showQuiz = !this.showQuiz;
          this.bringToFront('quiz');
          break;
        case 'showPoll':
          // this.showQuiz = false;
          // this.showWordCloud = false;
          // this.showWordCloudPrompt = false;
          // this.showQuestionOverlay = false;
          this.showPoll = !this.showPoll;
          this.bringToFront('poll');
          break;
        case 'showWordCloud':
          // this.showQuiz = false;
          // this.showPoll = false;
          // this.showQuestionOverlay = false;
          this.showWordCloud = !this.showWordCloud;
          this.showWordCloudPrompt = !this.showWordCloudPrompt;
          this.bringToFront('wordcloud');
          break;
        case 'showQuestionOverlay':
          // this.showQuiz = false;
          // this.showPoll = false;
          // this.showWordCloud = false;
          // this.showWordCloudPrompt = false;
          this.showQuestionOverlay = !this.showQuestionOverlay;
          this.bringToFront('qa');
          break;
      }
    },
    sendReaction(e, reaction) {
      const { target } = e;
      target.setAttribute('class', reaction.classAnimate);
      target.style.transform = 'scale(0.7)';
      setTimeout(() => {
        target.style.transform = 'scale(1)';
        target.setAttribute('class', reaction.classIdle);
      }, 100);

      this.animateReaction({ target: target }, reaction, false);

      if (!this.reactionApiBusy) {
        let msg = {
          type: 'reaction-input',
          userId: this.$store.state.user.id,
          name: this.$store.state.user.name || 'Anônimo',
          image: this.$store.state.user.picture,
          reaction: reaction.name,
          config: JSON.stringify(reaction),
          timestamp: Date.now(),
          channel: this.$route.params.stream,
        };

        this.wsClient.send(JSON.stringify(msg));

        const obj = {
          reaction: reaction.name,
          config: JSON.stringify(reaction),
        };

        if (this.activityData.property.disableReactionsAPI) return;
        else {
          api
            .post(`activity/${this.$route.params.stream}/reaction`, obj)
            .then((response) => {})
            .catch((err) => {
              console.error('error saving chat', err);
            });
          this.reactionApiBusy = true;
          setTimeout(() => {
            this.reactionApiBusy = false;
          }, this.reactionApiTimeout ?? 1000);
        }
      }
    },
    animateReaction(e, config, isThirdParty = false) {
      const { target } = e;
      const { parentNode } = target;
      isThirdParty ? target.setAttribute('class', config.classIdle) : target.setAttribute('class', config.classAnimate);

      const clone = document.createElement('i');
      clone.setAttribute('id', 'clone');
      clone.setAttribute('class', `${config.classAnimate} animateInteractivityIcon`);
      clone.style['z-index'] = '20';
      clone.style['left'] = '-8px';
      clone.style['font-size'] = `${Math.floor(Math.random() * (60 - 20 + 1)) + 20}px`;
      clone.style['color'] = this.randomColor();

      parentNode.prepend(clone);
      setTimeout(() => {
        clone.setAttribute('class', config.classIdle);
        parentNode.removeChild(clone);
      }, 30001);
      setTimeout(() => {
        target.setAttribute('class', config.classIdle);
      }, 100);
    },
    checkSendQuestion(key) {
      if (key.keyCode == 13) this.sendGeneralQuestion();
    },
    finishQuiz(answers) {
      api
        .post('/answerQuiz', {
          userId: this.$store.state.user.id,
          quiz_id: answers.id,
          answers: answers.answers,
          activity_id: this.$route.params.stream,
        })
        .then((response) => {
          // console.log('finishQuiz',response);
          this.$refs.quiz.setScore(response.data.score);
          let marker = `${this.$store.state.user.id}-${answers.id}`;
          this.$store.commit('setMarker', { target: 'answeredQuiz', marker: marker });
          setTimeout(() => {
            this.apiGetInteractivitiesStatus(true);
          }, 5000);
          if (response.data.score >= 1) {
            api.post(`sessionAction/`, {
              action: 'Quiz Answer Right',
              properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, quiz_id: answers.id }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          } else {
            api.post(`sessionAction/`, {
              action: 'Quiz Answer Wrong',
              properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, quiz_id: answers.id }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          }
        });
    },
    finishPoll(answer) {
      //console.log(answer);
      api
        .post(`/answerPoll/${this.$route.params.stream}`, {
          userId: this.$store.state.user.id,
          poll_id: answer.id,
          answer: answer.answer,
          activity_id: this.$route.params.stream,
        })
        .then((response) => {
          // console.log('finishPoll', { response });
          let marker = `${this.$store.state.user.id}-${answer.id}`;
          this.$store.commit('setMarker', { target: 'answeredPolls', marker: marker });
          this.apiGetInteractivitiesStatus();
          api.post(`sessionAction/`, {
            action: 'Poll Answer',
            properties: JSON.stringify({ route: this.$route.name, params: this.$route.params, poll_id: answer.id }),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
        });
    },
    getPollResults(id) {
      return new Promise((resolve, reject) => {
        api
          .get(`/event/${this.$store.state.eventId}/poll/${id}/result`)
          .then((response) => {
            // console.log('getPollResults', { response });
            resolve(response.data.answers);
          })
          .catch((error) => {
            console.error('getPollResults error', error);
            reject(error);
          });
      });
    },
    connectWs() {
      this.wsClient = new WebSocket('wss://websocket.blitzar.com.br');
      //this.wsClient = new WebSocket('wss://ws.blitzar.com.br');
      //this.wsClient = new WebSocket('ws://localhost:3334');
      const token = this.$store.state.user.token; //? this.$store.state.user.token : '3116d460-7cb1-11ea-bc55-0242ac130003';
      //this.wsClient = new WebSocket(`wss://mi0kxajewd.execute-api.us-east-1.amazonaws.com/prd?authToken=${token}`);
      //this.wsClient = new WebSocket(`ws://localhost:6262/ws?authToken=${token}`);
      this.wsClient.addEventListener('message', this.receiveMessage);
      this.wsClient.addEventListener('open', () => {
        this.wsClient.send(
          JSON.stringify({
            type: 'subscribe',
            channel: this.$route.params.stream,
          }),
        );
      });
      this.wsClient.addEventListener('close', () => {
        // this.wsClient.send(
        //   JSON.stringify({
        //     type: 'unsubscribe',
        //     channel: this.$route.params.stream,
        //   }),
        // );
        this.wsClient = null;
        setTimeout(this.connectWs, 300000);
      });
      this.wsClient.addEventListener('error', () => {
        this.wsClient.close();
      });
    },
    resized() {
      if (this.$refs && this.$refs.interactivitiesBar) {
        this.topQA = this.$refs.interactivitiesBar.getBoundingClientRect().top;
        this.leftQA = this.$refs.interactivitiesBar.getBoundingClientRect().right + 10;
        this.topRef = this.$refs.interactivitiesBar.getBoundingClientRect().top;
      }
      this.windowWidth = window.innerWidth;

      if (this.$refs.sideboxRef) this.$refs.sideboxRef.resized();
    },
    hideWordCloud() {
      this.showWordCloudPrompt = false;
    },
    logClick() {
      // console.log('CLICKED');
    },
    randomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    showLanguageSelector() {
      // if (this.$refs.languageSelector) this.$refs.languageSelector.style.visibility = 'visible';
    },
    hideLanguageSelector() {
      // if (this.$refs.languageSelector) this.$refs.languageSelector.style.visibility = 'hidden';
    },
    resizeQA(newRect) {
      // console.log('resizeQA');
      this.isDragging = true;
      this.widthQA = newRect.width;
      this.heightQA = newRect.height;
      this.topQA = newRect.top;
      this.leftQA = newRect.left;
    },
    dragstop() {
      // console.log('dragstop');
      this.isDragging = false;
    },
    passFocus(e) {
      // console.log('PassFocus: ', { e });
      this.$nextTick(() => {
        if (this.$refs.interactivitiesBar) this.$refs.interactivitiesBar.style['visibility'] = 'hidden';
        this.$refs.streamDetails.focus();
      });
    },
    passQAFocus() {
      this.$nextTick(() => {
        this.$refs.qaTextArea.focus();
      });
    },
    bringToFront(panelKey) {
      // console.log('bringToFront', { panelKey });
      Object.keys(this.panelZ).map((p) => {
        this.panelZ[p] = 1;
      });
      this.panelZ[panelKey] = 2;
    },
    checkWords(msg) {
      api
        .get(`activity/${this.$route.params.stream}/wordcloud/${msg.id}/result`)
        .then((response) => {
          // console.log('checkWords', { response });
          this.interactivitiesOnStatus = this.interactivitiesOnStatus.map((inter) => {
            if (inter.interactivity_id == msg.id) {
              inter.interactions = response.data;
              this.currentWordcloud = inter;
            }
            return inter;
          });
        })
        .catch((err) => {
          console.error(err);
        });
      // api
      //   .get(`activity/${this.$route.params.activityId}/wordcloud/${wordcloud.wordcloud_id}/forbidden`)
      //   .then((response) => {
      //     console.log('forbidden ', response.data);
      //     wordcloud.forbidden = response.data;
      //   })
      //   .catch((err) => {
      //     console.error(err);
      //   });
    },
    handlePIPList(id) {
      if (this.activePIPList.includes(id)) {
        this.activePIPList = this.activePIPList.filter((p) => p !== id);
      } else {
        this.activePIPList.push(id);
      }
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    this.accessConfig.interactivities = { ...this.$store.state.template.accessConfig.interactivities };
    this.isAdmin = this.$store.state.user.role === '1819bd5e-7b46-11ea-bc55-0242ac130003' || this.$store.state.user.role === '1819bea8-7b46-11ea-bc55-0242ac130003'; //operators and admins

    // UPDATE ACTIVITY INTERVAL
    if (Number.isSafeInteger(this.accessConfig.loadActivityIntervalInMiliseconds) && this.accessConfig.loadActivityIntervalInMiliseconds > this.loadActivityIntervalInMiliseconds) {
      this.loadActivityIntervalInMiliseconds = this.accessConfig.loadActivityIntervalInMiliseconds;
    }

    // GET ACCESS CONFIG ACORDING TO LANGUAGE
    let userLanguage = this.$store.state.user.language ? this.$store.state.user.language.toLowerCase() : 'pt';
    if (this.$store.state.template.multilanguagesConfig) {
      this.accessConfig = this.$store.state.template.accessConfig[`accessConfig_${userLanguage}`];
    }

    this.loadActivity();

    if (window.innerWidth <= 1080) this.isMobile = true;
    this.template = this.$store.state.template.live;
    this.audio = new Audio('https://www.redringtones.com/wp-content/uploads/2019/05/glass-tone.mp3');
    this.audio.volume = 0.5;
  },
  mounted() {
    this.currentWSChannel = this.$route.params.stream;
    window.addEventListener('resize', this.resized);
    this.updaterSetInterval = setInterval(() => {
      // console.log('updtr');
      this.loadActivity(true);
    }, this.loadActivityIntervalInMiliseconds);
    setTimeout((_) => {
      window.scrollTo(0, 0);
    }, 500);
    this.$nextTick(() => {
      this.resized();
    });
  },
  beforeDestroy() {
    if (this.wsClient) {
      this.wsClient.send(
        JSON.stringify({
          type: 'unsubscribe',
          channel: this.currentWSChannel,
        }),
      );
    }
    clearInterval(this.updaterSetInterval);
    window.removeEventListener('resize', this.resized);
  },
};
</script>
<style lang="scss">
.feed-container-embed {
  position: relative;
  width: 100%;
  padding: 2% 50% 0.5% 6%;

  @include media('<=phone-plus') {
    padding: 0% 3% 0.5% 3%;
  }
}

.live {
  position: fixed;
  inset: 0;
  width: 100%;
  max-width: 100vw;
  min-height: 98vh;
  overflow-x: hidden;
  background-color: var(--main-color);
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.live-all-container {
  position: relative;
  width: 100%;

  display: flex;
  justify-content: space-around;
  align-items: flex-start;

  @include media('<=tablet') {
    width: 100%;
    height: auto;
    margin-top: 60px;
    margin-bottom: 44px;

    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  @include media('<=phone-plus') {
    margin-top: 50px;
  }
  @include media('<=phone') {
    margin: 38px 0 100px 0;
  }

  @media (min-width: 1200px) and (max-width: 1300px) and (max-height: 720px) {
    max-width: 80vw;
  }
}

.live-side-banner-container,
.live-side-banner-second-container {
  width: 18%;
  height: 100%;
  padding: 120px 40px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background: teal;

  @include media('<=tablet') {
    padding: 10px 0px;
    max-height: 120px;
    height: auto;
    width: 100%;
    overflow-y: hidden;
  }

  @media (max-height: 720px) and (min-width: 920px) {
    width: 20%;
    padding: 110px 46px;
  }

  @include media('<=phone-plus') {
    padding: 0 !important;
    width: 100vw !important;
    overflow-y: hidden;
  }

  .live-side-banner {
    width: 100%;

    // height: calc(37vw + 20px);
    // background: #555;
    @include media('<=tablet') {
      width: 100vw;
      // margin-top: 99px;
      padding: 0 10px;
      display: flex;
      justify-content: center;
    }

    @include media('<=phone') {
      width: 100vw;
      // margin-top: 50px;
    }

    img {
      width: 100%;
      height: auto;
      object-fit: contain;
      object-position: top;

      @include media('<=tablet') {
        max-height: 120px;
        max-width: 720px;
      }
    }
  }
}

.live-side-banner-second-container {
  .live-side-banner-second {
    width: 100%;

    // height: calc(37vw + 20px);
    // background: #555;
    @include media('<=tablet') {
      width: 100vw;
      display: flex;
      justify-content: center;
      margin: 0;
      padding: 0 10px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: top;

      @include media('<=tablet') {
        max-height: 120px;
        max-width: 720px;
      }
    }
  }
}

.master-container {
  position: relative;
  background-color: transparent;
  flex-grow: 1;
  padding: 0 10%;
  margin: 0.4% 0 4% 0;
  overflow-x: hidden;
  // background: teal;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  justify-content: space-between;
  flex-flow: row;
  gap: 10px;

  @include media('<=tablet') {
    flex-grow: 0;
    width: 100%;
    max-width: 100%;
    min-height: unset;
    margin-top: 0;
    padding: 0;
    flex-direction: column;
    // height: calc(100dvh - 392px);
  }
}

.with-lateral-banners {
  margin: 2px 0 0 0;
  padding: 0 0 50px 0;
  height: auto;
  align-content: center;
  align-items: center;

  @media (max-height: 720px) {
    margin-top: 10px;
  }

  @include media('<=phone-plus') {
    margin: 0;
  }
}

.with-lateral-banners-and-chat {
  padding: 0;
  margin-top: 8%;
}

.with-header {
  padding-top: 100px;

  @include media('<=tablet') {
    padding: 0;
  }
}

@media (max-height: 460px) {
  .live-all-container {
    margin-top: 18px;
  }

  .master-container {
    max-width: 78%;
  }

  .with-header {
    padding: 0;
    padding-top: 36px !important;
    padding-bottom: 60px;
  }
}

.solo {
  max-width: 70%;

  @include media('<=tablet') {
    max-width: 100%;
    padding: 0 10px;
  }

  @media (max-height: 720px) and (min-width: 920px) {
    max-width: 60%;
  }

  @include media('<=phone') {
    max-width: 100%;
  }
}

.full-width-mode {
  padding-right: 0;
  padding-left: 0;
  max-width: 90%;
  justify-content: center;

  // set max width:80% for 720p and 1366x768
  @media (max-height: 770px) and (min-width: 1200px) {
    max-width: 100%;
  }
  @include media('<=phone-plus') {
    max-width: 100%;
  }
}

.player-container {
  max-width: 72%;
  flex-grow: 1;
  flex-shrink: 0;
  flex-direction: column;
  align-content: flex-start;
  // overflow-x: hidden;

  @include media('<=tablet') {
    width: 100%;
    max-width: 100%;
    margin: 10px 0;
  }

  @include media('<=phone-plus') {
    width: 100%;
    margin: 10px 0 4px 0;
    padding: 0;
  }
}

.player {
  position: relative;
  // width: 100%;
  margin-bottom: 20px;

  // overflow-x: hidden;
  &::before {
    content: '';
    float: left;
    padding-top: calc(9 / 16 * 100%);
    height: 0;
  }

  &::after {
    content: '';
    display: table;
    clear: both;
  }
}

.player-top-header-container {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  border-bottom: 4px solid transparent;

  @include media('<=phone-plus') {
    flex-direction: column-reverse;
    align-items: center;
    height: auto;
  }

  .player-title {
    // min-width: 30%;
    font-size: 1.6rem;
    font-weight: bold;
    margin: 6px 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    @include media('<=phone-plus') {
      font-size: 1.3rem;
      width: 96%;
      margin: 14px 0;
    }
  }
}

.player:-webkit-full-screen {
  width: 100vw;
  height: 100dvh;
  margin: 0 !important;
}

.video-container {
  flex-grow: 1;
  margin-top: 0px;
  overflow-x: hidden;
  z-index: 0;
}

.vimeo-iframe {
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.vimeo-iframe-solo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.rotateChevron {
  transform: scaleX(-100%);
}

.minimizer-bar {
  cursor: pointer;
  // position: absolute;
  // top: 0;
  // left: 0;
  // width: 14px;
  height: 100%;
  // opacity: 0.6;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  // background: black;
  // mix-blend-mode: difference;
  .minimizer-chevron {
    // margin-top: 18px;
    // border-right: 4px solid;
    // border-bottom: 4px solid;
    // height: 10px;
    // width: 10px;
    // transform: rotate(-45deg);
    // margin-right: 8px;
    margin: 2px 2px 0 6px;
    color: var(--live-itemColor);
    font-size: 0.98rem;
    transition: opacity 1s ease;

    &:hover {
      opacity: 0.7;
    }
  }
}

.emoji-reactions-container {
  position: absolute;
  bottom: 44px;
  right: 0px;
  width: auto;
  padding: 6px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  background: transparent;

  @include media('<=phone-plus') {
    z-index: 10;
  }
}

.player:hover > .interactivities-bar-container {
  visibility: visible !important;
}

.player:hover > .interactivities-bar-fullscreen-icon-container {
  visibility: visible;
}

.interactivities-bar-fullscreen-icon-container {
  position: absolute;
  bottom: 0;
  right: 0px;
  z-index: 1;
  color: var(--live-textColor);
  background-color: var(--live-bgColor);
  border-radius: 4px 0 0;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  visibility: hidden;
  transition: visibility 0.3s;

  .interactivities-bar-fullscreen-icon {
    cursor: pointer;
    position: relative;
    // border-radius: var(--live-borderRadius);
    padding: 11px 16px 9px;
    // height: 18px;
    // width: 18px;
    font-size: 1.4rem;

    &:hover {
      animation: fullscreenBtn-bounce 1s forwards;
    }
  }
}

.interactivities-bar-container {
  position: absolute;
  bottom: 50%;
  transform: translateY(50%);
  left: 0px;
  z-index: 3;
  padding: 4px 0 2px;
  color: var(--live-textColor);
  background: var(--live-bgColor);
  border-radius: 0 4px 4px 0;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;

  visibility: hidden; //hidden
  transition: visibility 0.3s;

  .interactivities-bar-icons {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;

    .interactivities-bar-item {
      position: relative;
      color: var(--live-textColor);
      font-size: 12px;
      margin: 2px 0px 8px 0px;
      padding: 0px 8px 0px 6px;
      user-select: none;
      cursor: pointer;
      opacity: 0.8;

      display: flex;
      flex-direction: column;
      align-items: center;

      ion-icon {
        cursor: pointer;
        position: relative;
        margin: 6px 2% 0 2%;
        height: 28px;
        width: 28px;

        @include media('<=phone-plus') {
          height: 22px;
          width: 22px;
        }

        display: flex;
      }

      p {
        text-align: center;
        max-width: 54px;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }

      &:hover {
        opacity: 1;
      }

      &:active {
        transform: scale(0.9);
      }
    }
  }
}

.interactivitiesBarIconBounce-enter-active {
  animation: icon-bounce 0.7s;
  animation-delay: 0.9s;
}

// .interactivitiesBarIconBounce-leave-active {
//   animation: icon-bounce 0.7s reverse;
//   animation-delay: 0.5s;
// }

@keyframes icon-bounce {
  0% {
    transform: scale(0);
  }

  25% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.5);
  }

  75% {
    transform: scale(1.3);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes fullscreenBtn-bounce {
  0% {
    transform: scale(0.7);
  }

  100% {
    transform: scale(1);
  }
}

.btnMeeting {
  position: absolute;
  z-index: 2;
  bottom: 48px;
  left: 14px;
  max-height: 30%;
  max-width: 100%;
  cursor: pointer;
  user-select: none;
  object-fit: contain;

  @include media('<=phone') {
    max-height: 46%;
  }
}

.full-meet-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: auto;
  // width: 100vw;
  z-index: 10;
  background-color: #000000a0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.full-meet-wrapper {
  position: relative;
  // background-color: red;
}

.full-meet-closeBtn {
  cursor: pointer;
  position: absolute;
  right: 0;
  height: 40px;
  width: 100%;
  z-index: 11;
  outline: none;
  border: none;
  background-color: transparent;
}

.full-meet-img {
  cursor: pointer;
  pointer-events: all;
  position: relative;

  @include media('<=phone-plus') {
    max-height: 160px;
  }
}

.btnQuestion {
  position: absolute;
  z-index: 2;
  bottom: 48px;
  left: 14px;
  max-height: 30%;
  max-width: 100%;
  cursor: pointer;
  user-select: none;
  object-fit: contain;

  @include media('<=phone') {
    max-height: 46%;
  }
}

.live-video-banner-container {
  position: absolute;
  top: 80%;
  right: 0;
  bottom: 50px;
  left: 0;
  height: auto;
  // width: 100vw;
  z-index: 1;
  // background-color: #000000a0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.links-overlay-container {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 20px;

  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  pointer-events: none;
}

.link-onscreen {
  position: relative;
  pointer-events: auto;
  max-height: 20%;
  z-index: 1;

  .link-onscreen-image {
    object-fit: contain;
    width: auto;
    max-height: 100px;

    @include media('<=phone-plus') {
      max-height: 60px;
    }
  }
}

.pip-link-onscreen {
  position: relative;
  z-index: 2;
  pointer-events: auto;
  cursor: pointer;
}

.pip-preview-iframe {
  pointer-events: none;
  width: 100%;
  // height: 100%;
  max-height: 26%;

  @include media('<=tablet') {
    max-width: 100px;
    max-height: 60px;
  }
}

.pip-preview-video-player {
  pointer-events: auto;
  cursor: pointer;
  position: relative;
  width: 16vw;
  height: calc(16vw * 0.5625);
  // max-width: 300px;
  // max-height: 154px;
  z-index: 3;
}

.question-overlay {
  position: fixed;
  top: 38%;
  left: 78px;
  min-width: 400px;
  border-radius: var(--input-borderRadius);

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: #111;

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: blur(20px) brightness(0.6);
    backdrop-filter: blur(20px) brightness(0.6);
  }

  @include media('<=phone-plus') {
    position: fixed;
    inset: 10px auto auto 40px;
    min-width: unset;
  }

  .content-container {
    width: 100% !important;
    height: 100% !important;

    @include media('<=phone-plus') {
      width: 300px !important;
      max-width: 300px !important;
    }
  }

  .question-close-button {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    margin-top: auto;
    color: #ddd;
    margin: 0 14px 14px;
    border-radius: var(--input-borderRadius);
    padding: 9px;
    font-size: 1.3rem;
    font-weight: 300;
    text-align: left;
  }

  .input-question {
    // caret-color: red;
    font-size: 1.5rem;
    letter-spacing: 1px;
    outline: none;
    border: none;
    resize: none;
    padding: 10px;
    height: 120px;
    width: 100%;
    color: white;
    background: transparent;
    backdrop-filter: blur(20px) brightness(0.6);

    border-radius: var(--input-borderRadius);
    cursor: grab;

    &::placeholder {
      color: white;
      opacity: 0.73;
      cursor: auto;
    }
  }

  .question-send-button {
    position: relative;
    width: 96%;
    padding: 2% 8%;
    margin: 0 0 10px 10px;
    z-index: 1;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
    color: var(--live-textColor);
    // opacity: 0.8;
    background-color: var(--live-bgColor);
    // border-radius: var(--input-borderRadius);
    border: none;
    border-top: 2px solid var(--live-bgColor);
    border-radius: var(--input-borderRadius);
    outline: none;
    cursor: pointer;
  }
}

.quiz,
.poll {
  cursor: grab;
  position: fixed;
  left: 78px;
  top: 25%;
  min-width: 260px;
  height: auto;
  border-radius: var(--input-borderRadius);
  padding: 0 0 12px 0;
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  background: #111;

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background: none;
    -webkit-backdrop-filter: blur(20px) brightness(0.6);
    backdrop-filter: blur(20px) brightness(0.6);
  }

  @include media('<=phone-plus') {
    position: fixed;
    inset: auto auto auto 40px;
    width: unset;
  }

  .content-container {
    width: 100% !important;
    height: 100% !important;

    @include media('<=phone-plus') {
      height: auto !important;
    }
  }

  .box-title {
    background: var(--live-bgColor);
    color: var(--live-textColor);
    font-size: 1rem;
    padding: 8px 0;
    text-align: center;
    font-weight: bold;

    display: flex;
    align-items: center;
    justify-content: space-evenly;

    i {
      opacity: 0.5;
    }
  }
}

.quiz {
  .quiz-close-button {
    // background: red;
    position: absolute;
    right: 4px;
    top: 0px;
    // height: 100%;
    // width: 300px;
    z-index: 1;
    margin-top: auto;
    color: var(--live-textColor);
    margin-left: 8px;
    margin-right: 0px;
    margin-bottom: 3px;
    background: transparent;
    border-radius: var(--input-borderRadius);
    padding: 9px;
    font-size: 0.8rem;
    font-weight: 300;
    text-align: left;
  }

  .interactivity-contents {
    position: relative;
    max-width: 320px;
    .question-container {
      display: flex;
      flex-direction: column;

      .question {
        position: relative;
        max-width: 300px;
        color: whitesmoke;
        margin-top: 20px;
        margin-bottom: 20px;
        margin-left: 10px;
        margin-right: 8px;
        font-weight: bold;
        text-align: left;
      }
    }

    .box-answers {
      width: 100%;
      margin-top: auto;
      padding: 0 9px;
      font-size: 0.8rem;
      font-weight: 300;

      display: flex;
      flex-direction: column;

      .answer {
        z-index: 8;
        margin-top: auto;
        color: var(--live-textColor);
        background-color: var(--live-bgColor);
        border: 1px solid var(--input-outline);
        border-radius: calc(var(--input-borderRadius) - 4px);
        padding: 9px;
        padding-left: 15px;
        font-size: 0.8rem;
        font-weight: 300;
        text-align: left;
        margin-bottom: 5px;

        &:hover {
          filter: brightness(85%);
        }
      }
    }
  }

  .result {
    position: relative;
    max-width: 320px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 10px;
    margin-right: 8px;
    font-size: 20px;
    text-align: center;

    .close {
      display: none;
    }
  }
}

.poll {
  .poll-close-button {
    position: absolute;
    right: 4px;
    top: 0px;
    // height: 100%;
    // width: 300px;
    z-index: 1;
    margin-top: auto;
    color: var(--live-textColor);
    margin-left: 8px;
    margin-right: 0px;
    margin-bottom: 3px;
    background: transparent;
    border-radius: var(--input-borderRadius);
    padding: 9px;
    font-size: 0.8rem;
    font-weight: 300;
    text-align: left;
  }

  .interactivity-contents {
    position: relative;
    max-width: 320px;
    padding-right: 20px;

    .question-container {
      display: flex;
      flex-direction: column;

      .question {
        position: relative;
        max-width: 300px;
        color: whitesmoke;
        margin-top: 20px;
        margin-bottom: 20px;
        margin-left: 12px;
        margin-right: 8px;
        font-weight: bold;
        text-align: left;
      }
    }

    .box-answers {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-top: auto;
      margin: 0 9px;
      background-color: var(--live-bgColor);
      border-radius: calc(var(--input-borderRadius) - 4px);
      border: 1px solid var(--input-outline);
      padding: 9px;
      padding-left: 15px;
      padding-right: 15px;
      margin-bottom: 5px;

      .answerContainer {
        display: flex;
        align-items: center;
        width: 100%;

        .answer {
          color: var(--live-textColor);
          margin-right: auto;
          border-radius: var(--input-borderRadius);
          font-size: 0.8rem;
          font-weight: 300;
        }

        .option-score {
          color: var(--live-textColor);
          opacity: 0.8;
          font-size: 0.8rem;
          align-self: center;
        }
      }

      &:hover {
        filter: brightness(85%);
      }
    }
  }
}

.button-control {
  position: relative;
}

.poster-live {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  object-fit: contain;
}

.stream-details {
  position: relative;
  width: 100%;
  display: block;
  padding: 0 0 20px;
  color: var(--text-color) !important;
  // border-bottom: 1px solid var(--separator-color);
}

.stream-name {
  position: relative;
  flex-grow: 1;
  padding: 0;
  padding-top: 0.4%;
  text-align: left;
  color: var(--text-color) !important;
}

.user-avatar {
  align-self: flex-start;
  position: relative;
  // margin-right: 10px;
  flex-shrink: 0;
  flex-grow: 0;
  height: 30px;
  width: 30px;
  border-radius: 50%;
}

.speaker {
  position: relative;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  // padding-top: 2%;
  // padding-bottom: 2%;
  justify-content: flex-start;

  .speaker-details {
    display: flex;
    justify-content: flex-start;
    padding-top: 2%;
    padding-bottom: 2%;
    padding-right: 4%;

    @include media('<=phone') {
      padding-top: 4%;
    }

    .speaker-info {
      display: flex;
      min-width: 100%;
      flex-direction: column;
      align-items: flex-start;
      padding-left: 4%;

      .speaker-name {
        color: var(--text-color);
        font-size: 2.7vh;

        @include media('<=tablet') {
          font-size: 1.5rem;
        }
      }

      .speaker-role {
        color: var(--live-bgColor);
        font-size: 1.6vh;

        @include media('<=tablet') {
          font-size: 1rem;
        }
      }
    }

    .speaker-picture {
      position: relative;
      border-radius: 50%;
      width: 50px;
      height: 50px;
    }
  }
}

.language-selector-container {
  position: relative;
  align-self: center;
  display: flex;
  justify-content: flex-end;
  margin-top: -21px;
  align-items: center;
  background: transparent;
  margin-left: auto;
  color: var(--live-textColor);
  // visibility: hidden;
  // opacity: 0.8;
  // transition: visibility 2.3s;

  // &:hover {
  // visibility: visible !important;
  // }

  img {
    height: 14px;
  }

  .language-selector-wrapper {
    background: var(--live-bgColor);
    display: flex;
    align-items: center;
    padding: 0 3px;
  }

  .language-selector {
    // background-color: teal;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .language-selector-select {
    color: var(--live-textColor);
    font-size: 0.8rem;
    border: none;
    outline: none;
    background: var(--live-bgColor);

    .selector-option {
      color: var(--live-textColor);
      background: var(--live-bgColor);

      &:disabled {
        color: white !important;
        background: #ddd;
      }

      &:invalid {
        color: var(--live-textColor);
        background: var(--live-bgColor);
      }
    }
  }
}

// Typography (And Color)//
.trail-name {
  position: relative;
  font-size: 1.6vh;
  font-weight: 600;
  color: var(--live-bgColor);

  @include media('<=tablet') {
    font-size: 1rem;
  }
}

.stream-name {
  // margin: 0;
  font-size: 3.8vh;
  font-weight: 600;
  margin-bottom: 20px;
  color: var(--main-color);

  @include media('<=tablet') {
    font-size: 2rem;
  }
}

.stream-description {
  font-size: 2.3vh;

  @include media('<=tablet') {
    font-size: 1.4rem;
  }

  @include media('<=phone') {
    margin: 0 10px;
  }
}

.live-watermark {
  position: absolute;
  top: 2%;
  right: 2%;
  font-size: 0.8rem;
  letter-spacing: 0.07rem;
  color: #eeeeee;
  background: #000000bb;
  border-radius: 6px;
  pointer-events: none;
  padding: 0px 7px 0 10px;
}

.live-watermark-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-size: 0.8rem;
  letter-spacing: 0.07rem;
  color: #eeeeee;
  // background: #000000bb;
  pointer-events: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .username-tilt {
    font-size: 7rem;
    opacity: 0.15;
    transform: rotate(-24deg);
    -webkit-transform: rotate(-24deg);
    -moz-transform: rotate(-24deg);
  }
}

// REACTIONS ANIMATIONS
.fa,
.fas,
.far,
.fab {
  cursor: pointer;
  position: relative;
  font-size: 20px;
  z-index: 20;
  margin: 4px;
}

.generator {
  position: relative;
  margin: 4px;
}

@keyframes float {
  0% {
    opacity: 0.7;
    top: 20%;
    transform: rotateZ(0deg) scale(0);
  }

  3% {
    transform: scale(0.2);
  }

  12% {
    transform: rotateZ(-20deg) scale(0.9);
  }

  24% {
    transform: rotateZ(20deg) scale(0.7);
    right: 22%;
    opacity: 0.4;
  }

  40% {
    transform: rotateZ(-11deg) scale(0.6);
    right: 8%;
  }

  70% {
    transform: rotateZ(10deg) scale(0.4);
    right: 23%;
    opacity: 0.2;
  }

  90% {
    transform: scale(0.2);
    right: 7%;
    opacity: 0.01;
  }

  100% {
    opacity: 0;
    top: -600px;
    right: 0;
    transform: rotateZ(-5deg) scale(0.1);
  }
}

.animateInteractivityIcon {
  position: absolute;
  top: 0em;
  left: 0;
  animation: float 2s linear forwards;
}

.hidden-chatbox {
  display: none;
}
</style>
